export const polygonsPath = 'dashboard-tools';
